import React, { useEffect } from 'react';
import Select from "react-select";
import { getAllClinic } from "../../../../../store/slices/clinicSlice";
import { useDispatch, useSelector } from "react-redux";

const LabOutsource = ({ handleSelectAllOutsourceToggle, selectAllOutsource, handleGlobalRadiologyServiceChange, globalOutsourceLab }) => {
  const dispatch = useDispatch();
  const { allClinicLists } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getAllClinic({token}));
  }, [dispatch, token]);

  return (
    <div className="card">
      <div className="card-body d-flex align-items-center gap-3">
        <h4>Select Lab For Outsource :</h4>
        {selectAllOutsource && (
          <div className="form-group" style={{ width: "22rem" }}>
            <Select
              placeholder="Select  Lab"
              value={globalOutsourceLab}
              onChange={handleGlobalRadiologyServiceChange}
              options={allClinicLists.map((item) => ({
                value: item._id,
                label: item?.clinicName,
              }))}
            />
          </div>
        )}
        <div className="form-check custom-checkbox mb-3 ms-3 checkbox-info">
          <input
            type="checkbox"
            className="form-check-input"
            id="customCheckBox2"
            name='checkAll'
            checked={selectAllOutsource}
            onChange={handleSelectAllOutsourceToggle}
          />
          <label
            className="form-check-label"
            htmlFor="customCheckBox2"
          >
            Check All Tests To Out Source.
          </label>
        </div>
      </div>
    </div>
  )
}

export default LabOutsource;